<div class="event-item">
  <div class="event-head">
    <span class="event-label">{{ label }}</span>
    <p-tag *ngIf="event.type === 'client.won'" value="Ganado" severity="success"></p-tag>
    <p-tag *ngIf="event.type === 'client.lost'" value="Perdido" severity="danger"></p-tag>
    <span class="event-time">{{ event.occurredAt | timeElapsed }}</span>
  </div>
  <div class="event-meta">
    <span>por {{ actor }}</span>
    <span *ngIf="channelLabel"> · canal {{ channelLabel }}</span>
    <span *ngIf="lossReasonLabel"> · causa: {{ lossReasonLabel }}</span>
    <span *ngIf="assignmentDetail"> · {{ assignmentDetail }}</span>
  </div>
</div>
